<template>
  <vs-popup id="popupRiskStrength" title="<표 2> 위험발생 중대성 (강도)" :active.sync="popupActiveSync">
    <div class="p-4">
      <table>
        <thead>
          <tr>
            <th>위험강도</th>
            <th>인적피해(年)</th>
            <th>손실금액(年)</th>
            <th>Line 정지(年)</th>
            <th>작업환경(年)</th>
            <th>근골격양성자(年)</th>
          </tr>
        </thead>
        <tbody>
        <tr>
          <td>5(HH)</td>
          <td>중대재해</td>
          <td>손실금액 1억원 이상</td>
          <td>Line 정지 16일 이상</td>
          <td>허용기준 초과</td>
          <td>“양성자” 4명 이상</td>
        </tr>
        <tr>
          <td>4(HM)</td>
          <td>요양기간 91일 이상</td>
          <td>손실금액 5천만원 이상</td>
          <td>Line 정지 11~15일</td>
          <td>허용기 81~100%</td>
          <td>“양성자” 3명 이상</td>
        </tr>
        <tr>
          <td>3(MM)</td>
          <td>요양기간 31~90일</td>
          <td>손실금액 5백만원 이상</td>
          <td>Line 정지 6~10일</td>
          <td>허용기 61~80%</td>
          <td>“양성자” 2명 이상</td>
        </tr>
        <tr>
          <td>2(ML)</td>
          <td>요양기간 4~30일</td>
          <td>손실금액 5백만원 이하</td>
          <td>Line 정지 2~5일</td>
          <td>허용기 41~60%</td>
          <td>“양성자” 1명 이상</td>
        </tr>
        <tr>
          <td>1(LL)</td>
          <td>요양기간 4일 미만</td>
          <td>손실금액 1백만원 이하</td>
          <td>Line 정지 1일 이하</td>
          <td>허용기 40% 이하</td>
          <td>“양성자” 발생 없음</td>
        </tr>
        </tbody>
      </table>
    </div>
  </vs-popup>
</template>

<script>
export default {
  name: 'PopupRiskDksteelStrength',
  props: {
    value: Boolean,
  },
  components: {
  },
  computed: {
    popupActiveSync: {
      get () {
        return this.value
      },
      set () {
        this.handleCloseSelf()
      }
    }
  },
  methods: {
    handleCloseSelf () {
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="scss" scoped>
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th,
  td {
    border: 1px solid #cdcdcd;
    padding: 14px;
    text-align: center;
    font-size: 14px;
    color: #3c3c3c;
    line-height: 20px;
  }

  thead {
    th {
      font-weight: 700;
      background: #f9f9f9;
    }
  }
  tbody {
    td {
      font-weight: 400;
    }
  }
}
</style>
<style>

#popupRiskStrength > .vs-popup {
  width: 1167px !important;
}

#popupRiskStrength > .vs-popup > .vs-popup--content {
  width: 100%;
  padding: 0;
  margin: 0;
}

#popupRiskStrength > .vs-popup > .vs-popup--content > .vs-row {
  padding: 24px;

}

</style>
